/*
 * Predictive search dropdown — наш нативний пошук (30.08).
 * - Звичайні продукти: Shopify Predictive Search (/search/suggest.json).
 * - Прихована S-Cloud категорія (seo.hidden=1, поза suggest.json): тягнемо
 *   секцію ps-scloud-suggest через Section Rendering ЛИШЕ коли юзер друкує
 *   синонім (soundcloud/s-cloud/cloud) — у коді сторінок цього нема, сканер
 *   не бачить, а юзер знаходить.
 * Vanilla, без залежностей; debounce за нашими INP-правилами.
 */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MIN = 1, DEBOUNCE = 120, LIMIT = 8, SC_MAX = 8;
  var SC_COLLECTION = ROOT + 'collections/s-cloud-promotion';

  var input, box, timer, lastQuery = '', scloudCache = null;
  // 25.09.2026 трекінг: одна подія GA4 'search' (search_term → вбудований вимір GA4, без реєстрації) на ЗАВЕРШЕНИЙ пошук -
  // клік по результату / Enter / закриття / вихід / 3с тиші. Раніше search_query і search_no_results летіли на кожну паузу
  // набору (859 подій на 55 людей) і без тексту в GA4.
  var lastCount = 0, committed = '', idleTimer = null, IDLE_COMMIT = 3000;
  function commitSearch(outcome) {
    clearTimeout(idleTimer);
    var q = (lastQuery || '').trim();
    if (!q || q === committed) return;
    committed = q;
    var p = { search_term: q.slice(0, 100), results: lastCount, outcome: outcome };
    window.psTrack && psTrack('search', p, { search_term: q });
    if (!lastCount) window.psTrack && psTrack('search_no_results', p, { search_term: q });
  }

  // Синонім прихованої категорії: нормалізуємо запит і матчимо частково
  function isScloud(q) {
    var n = q.toLowerCase().replace(/[^a-z]/g, '');
    if (n.length < 3) return false;
    return 'soundcloud'.indexOf(n) !== -1 || n.indexOf('soundcloud') !== -1 ||
           'scloud'.indexOf(n) !== -1 || n.indexOf('scloud') !== -1;
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  // ЛОКАЛЬНИЙ ІНДЕКС каталогу (207 продуктів, ~20KB): одне завантаження →
  // пошук на кожну літеру за <1мс без мережі. Покриває ВСЕ, включно з
  // прихованими від нативного індексу (S-Cloud).
  var INDEX = null, indexLoading = false;
  // Пакети S-Cloud - бандли без «:» у назві (на запит «soundcloud package»)
  var SC_PACKAGES = ['s-cloud-algorithm-pusher', 's-cloud-comments-likes', 's-cloud-organic-booster', 's-cloud-hip-hop-organic-booster', 's-cloud-plays-likes-comments'];
  // 16.10.2026: товар іде в архів (рішення власника) - прибрати з індексу, щоб не підтягувався в ранжування "radio"
  var EXCLUDE_HANDLES = ['fm-online-radio-airplay-30-days'];
  function loadIndex() {
    if (INDEX || indexLoading) return;
    indexLoading = true;
    fetch(ROOT + 'products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        INDEX = (d.products || []).filter(function (p) { return EXCLUDE_HANDLES.indexOf(p.handle) === -1; }).map(function (p) {
          // v2: бандл («Spotify Basic: …» або пакет S-Cloud) отримує слово 'bundle' - на запит package/bundle;
          // «5,000» у назві → «5000», щоб число з запиту («5000 plays») збігалося
          var isBundle = (/-(basic|standard|premium|ultra)$/.test(p.handle) && p.title.indexOf(':') !== -1) || SC_PACKAGES.indexOf(p.handle) !== -1;
          var tNum = p.title.replace(/(\d),(?=\d{3}\b)/g, '$1');
          // 21.10.2026: приховані варіанти (custom.hidden) не беруть участі в «From $X»; якщо приховано все - рахуємо з усіх
          var HID = window.PS_HIDDEN_VARIANTS || [];
          var vis = (p.variants || []).filter(function (v) { return HID.indexOf(v.id) === -1; });
          if (!vis.length) vis = p.variants || [];
          var prices = vis.map(function (v) { return parseFloat(v.price); });
          var mn = prices.length ? Math.min.apply(null, prices) : null;
          var mx = prices.length ? Math.max.apply(null, prices) : null;
          return {
            t: p.title,
            tl: (p.title + ' ' + p.handle).toLowerCase(),
            words: (tNum + ' ' + p.handle.replace(/-/g, ' ') + (isBundle ? ' bundle' : '')).toLowerCase().split(/[^a-z0-9]+/),
            u: ROOT + 'products/' + p.handle,
            pm: mn, varies: mn !== null && mn !== mx
          };
        });
      })
      .catch(function () { indexLoading = false; });
  }

  function scoreProduct(pr, tokens) {
    var total = 0;
    for (var i = 0; i < tokens.length; i++) {
      var tk = tokens[i], best = 0;
      for (var w = 0; w < pr.words.length; w++) {
        var word = pr.words[w];
        if (!word) continue;
        if (word === tk) { best = Math.max(best, 5); }
        else if (word.indexOf(tk) === 0) { best = Math.max(best, 4); }
        else if (word.replace(/[aeiou]/g, '').indexOf(tk) === 0 && tk.length >= 2) { best = Math.max(best, 2); }
        else if (word.indexOf(tk) > 0) { best = Math.max(best, 1); }
      }
      if (!best) return 0; // усі токени мають матчитись
      total += best;
    }
    return total;
  }

  function localSearch(nq, scOnly) {
    var tokens = nq.split(/[^a-z0-9]+/).filter(Boolean); // 's-cl' → ['s','cl']
    if (!tokens.length) return [];
    var out = [];
    for (var i = 0; i < INDEX.length; i++) {
      var pr = INDEX[i];
      if (scOnly && pr.u.indexOf('s-cloud') === -1) continue;
      var sc = scoreProduct(pr, tokens);
      if (sc > 0) out.push([sc, pr]);
    }
    out.sort(function (a, b) { return b[0] - a[0] || a[1].t.length - b[1].t.length; });
    return out.slice(0, LIMIT).map(function (x) { return x[1]; });
  }

  function rowLocal(pr, pc) {
    var pv = pr.pm != null ? ((pr.varies ? '<span class="psq-row__from">From</span> ' : '') + '$' + (pr.pm % 1 ? pr.pm.toFixed(2) : pr.pm)) : '';
    var price = pv ? '<span class="psq-row__price">' + pv + '</span>' : '';
    var ico = pc ? '<span class="psq-row__ico psq-row__ico--plat ' + pc + '"><i class="svc-card__image"></i></span>'
                 : '<span class="psq-row__ico"></span>';
    return '<a class="psq-row" href="' + pr.u + '">' + ico +
      '<span class="psq-row__title">' + esc(pr.t) + '</span>' + price +
      '<svg class="psq-row__arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
  }

  // Словник друкарських помилок/синонімів → канонічний термін (для fetch;
  // те, що юзер бачить у полі, не змінюємо)
  var TYPO = {
    'yotube':'youtube','youtub':'youtube','utube':'youtube','you tube':'youtube','yt':'youtube',
    'spotifi':'spotify','spotefy':'spotify','sportify':'spotify','spotfy':'spotify','spoti':'spotify',
    'tiktoc':'tiktok','tik tok':'tiktok','tick tock':'tiktok',
    'instagramm':'instagram','insta':'instagram','ig':'instagram',
    'facebok':'facebook','fb':'facebook',
    'beatpot':'beatport','beat port':'beatport',
    'subs':'subscribers','subscibers':'subscribers',
    'listeners':'monthly listeners','hörer':'monthly listeners','horer':'monthly listeners',
    'streams':'plays','folowers':'followers','followrs':'followers'
  };

  // Фаззі по огризках: 'spt'→spotify, 'ytb'→youtube (префікс назви АБО її
  // скелета без голосних)
  var PLATFORMS = ['spotify', 'youtube', 'tiktok', 'instagram', 'facebook', 'soundcloud', 'beatport', 'mixcloud', 'deezer', 'tidal', 'twitch', 'threads', 'bandcamp', 'audiomack', 'traxsource', 'pandora', 'napster', 'itunes', 'boomplay', 'shazam', 'reverbnation'];
  function fuzzyPlatform(tok) {
    if (tok.length < 3) return null;
    for (var i = 0; i < PLATFORMS.length; i++) {
      var pl = PLATFORMS[i];
      var skel = pl.replace(/[aeiou]/g, '');
      if (pl.indexOf(tok) === 0 || skel.indexOf(tok) === 0) return pl;
    }
    return null;
  }

  function normalizeQuery(q) {
    var n = ' ' + q.toLowerCase().trim() + ' ';
    for (var k in TYPO) {
      if (n.indexOf(' ' + k + ' ') !== -1) n = n.split(' ' + k + ' ').join(' ' + TYPO[k] + ' ');
    }
    // фаззі-платформи по токенах
    n = n.trim().split(/\s+/).map(function (t) {
      if (PLATFORMS.indexOf(t) !== -1) return t;
      return fuzzyPlatform(t) || t;
    }).join(' ');
    // фінально: soundcloud → s-cloud (у каталозі бренд замаскований)
    n = n.replace(/sound\s*cloud|soundcloud/g, 's-cloud');
    return n;
  }

  // ===== ПОШУК v2 (25.09.2026): словник + каскад. Джерело правди словника - knowledge/SEARCH-SYNONYMS.md,
  // перевірено на 1178 реальних запитах GA4 (нуль 44% → 16%). Оновлення раз на місяць: scripts/search-queries-report.py
  var SV = {};

  // 1) Фрази (до токенізації). Порядок важливий: довші першими.
  SV.PHRASES = [
    ['sound cloud', 'soundcloud'], ['sound clound', 'soundcloud'], ['s cloud', 's-cloud'],
    ['you tube', 'youtube'], ['tik tok', 'tiktok'], ['tick tock', 'tiktok'], ['tic toc', 'tiktok'], ['tik tik', 'tiktok'],
    ['beat port', 'beatport'], ['boom play', 'boomplay'], ['reverb nation', 'reverbnation'], ['apple music', 'apple music'], ['itunes music', 'itunes'],
    // 28.09.2026: з'явився товар Watch Hours (підпродукт YouTube Views) - watch time/hours ведемо на нього, а не на views
    ['watch time', 'youtube hours'], ['watch hours', 'youtube hours'], ['watch hour', 'youtube hours'], ['watchtime', 'youtube hours'],
    ['monthly listeners', 'monthly listeners'], ['monatliche horer', 'monthly listeners'], ['monatliche hörer', 'monthly listeners'],
    ['me gusta', 'likes'], ['mi piace', 'likes'], ["j'aime", 'likes'],
    ['promo code', 'discount'], ['discount code', 'discount'], ['coupon code', 'discount'],
    ['order status', 'order'], ['track my order', 'order'], ['my order', 'order'],
    ['resident advisor', 'resident advisor'], ['ra event', 'event attendance'],
    // 16.10.2026: Radio Airplay / Music Blogs - нульові запити з GSC (knowledge/SEARCH-SYNONYMS.md §6)
    ['radio stations', 'radio airplay'], ['radio station', 'radio airplay'],
    ['radio-friendly', 'radio airplay'], ['radio friendly', 'radio airplay'],
    ['press promotion', 'blog placement radio airplay'],
    // "music blog(s)" без "music" - generic-слово звужувало строгий AND лише до одного товару
    // (music-blog-placement), не показуючи hip-hop-blog-placement поруч
    ['music blogs', 'blog placement'], ['music blog', 'blog placement'],
    // "release pr" (не "pr package") - слово package глобально мапиться на bundle (рядок SV.WORDS),
    // а в товара release-pr-package власне слово "package", не "bundle" - з package замість release+pr матч ламався
    ['music pr', 'release pr'],
    ['album release promotion', 'release pr']
  ];

  // 2) Слова → канон (опечатки, мови, синоніми). Ключ = нижній регістр як ввів юзер.
  SV.WORDS = {
    // платформи: скорочення, кирилиця
    yt:'youtube', ytb:'youtube', utube:'youtube', youtub:'youtube', yotube:'youtube', ютуб:'youtube', ютюб:'youtube',
    ig:'instagram', insta:'instagram', inst:'instagram', instagramm:'instagram', инстаграм:'instagram', інстаграм:'instagram', инста:'instagram',
    fb:'facebook', facebok:'facebook', фейсбук:'facebook',
    spoti:'spotify', spotifi:'spotify', sportify:'spotify', spotfy:'spotify', spotefy:'spotify', спотифай:'spotify', спотіфай:'spotify',
    tiktoc:'tiktok', tt:'tiktok', тикток:'tiktok', тікток:'tiktok',
    sc:'soundcloud', souncloud:'soundcloud', soundclod:'soundcloud', soudncloud:'soundcloud', саундклауд:'soundcloud',
    // GSC 25.09: часті опечатки з показами
    audiomark:'audiomack', audiomac:'audiomack', timtok:'tiktok', yourube:'youtube', spoitfy:'spotify', spotigy:'spotify', pandroa:'pandora', instgram:'instagram', instragram:'instagram',
    ra:'resident', applemusic:'apple music',
    // 16.10.2026: "radio station(s)" без фрази-збігу (напр. окреме слово) все одно веде на radio
    station:'radio', stations:'radio',
    // метрики EN
    subs:'subscribers', sub:'subscribers', subscribe:'subscribers', subscription:'subscribers',
    follow:'followers', follows:'followers', fans:'followers', fan:'followers',
    streaming:'plays', listens:'plays', listen:'plays', play:'plays',
    listeners:'monthly listeners', listener:'monthly listeners',
    view:'views', watch:'views', watched:'views', impressions:'views',
    // 28.09.2026: монетизація YouTube = 4000 годин перегляду → Watch Hours (+ help-рядок royalties лишається, бо ключ 'monetization' зберігається)
    monetization:'monetization youtube hours', monetize:'monetization youtube hours', monetisation:'monetization youtube hours', monetized:'monetization youtube hours',
    like:'likes', hearts:'likes', heart:'likes',
    comment:'comments', komments:'comments', koments:'comments',
    save:'saves', repost:'reposts', share:'shares',
    // ES / PT / FR / DE / IT / ID / TR / UA / RU
    seguidores:'followers', seguidor:'followers', abonnés:'followers', abonnes:'followers', follower:'followers',
    pengikut:'followers', takipci:'followers', takipçi:'followers', volgers:'followers', seguaci:'followers',
    подписчики:'followers', підписники:'followers', фолловеры:'followers',
    suscriptores:'subscribers', suscriptor:'subscribers', inscritos:'subscribers', abonnenten:'subscribers', iscritti:'subscribers',
    vistas:'views', visualizaciones:'views', visualizações:'views', visualizacoes:'views', vues:'views', aufrufe:'views',
    visualizzazioni:'views', izlenme:'views', tayangan:'views', просмотры:'views', перегляди:'views',
    reproducciones:'plays', reproduções:'plays', reproducoes:'plays', écoutes:'plays', ecoutes:'plays', wiedergaben:'plays',
    ascolti:'plays', dinlenme:'plays', прослушивания:'plays', прослуховування:'plays',
    oyentes:'monthly listeners', ouvintes:'monthly listeners', auditeurs:'monthly listeners', hörer:'monthly listeners', horer:'monthly listeners',
    ascoltatori:'monthly listeners',
    curtidas:'likes', megusta:'likes', jaime:'likes', beğeni:'likes', begeni:'likes', suka:'likes', лайки:'likes', лайків:'likes',
    comentarios:'comments', comentários:'comments', commentaires:'comments', kommentare:'comments', commenti:'comments',
    yorum:'comments', komentar:'comments', комментарии:'comments', коментарі:'comments',
    guardados:'saves', salvamentos:'saves', compartidos:'shares', compartilhamentos:'shares', partages:'shares',
    musica:'music', música:'music', musik:'music', musique:'music', artistas:'artist', artista:'artist', artists:'artist', künstler:'artist',
    // пакети
    package:'bundle', packages:'bundle', pack:'bundle', packs:'bundle', bundles:'bundle', combo:'bundle', paquete:'bundle', paket:'bundle', pacote:'bundle',
    // безкоштовно / купити → стоп (free-намір фіксуємо окремо)
    gratis:'free', gratuit:'free', gratuito:'free', gratuita:'free', grátis:'free', kostenlos:'free', bedava:'free', бесплатно:'free', безкоштовно:'free',
    comprar:'buy', kaufen:'buy', acheter:'buy', comprare:'buy', beli:'buy', kopen:'buy', satın:'buy', satin:'buy', kupić:'buy', купить:'buy', купити:'buy',
    monatliche:'monthly', mensuales:'monthly', mensuels:'monthly', mensais:'monthly', mensual:'monthly', zuhörer:'monthly listeners',
    promocion:'promotion', promoción:'promotion', promoção:'promotion', promo:'promotion', promote:'promotion', promoting:'promotion', marketing:'promotion'
  };

  // 3) Стоп-слова: не несуть товару, лише ламають AND
  SV.STOP = ['free','buy','get','cheap','best','how','to','for','the','a','an','my','me','i','on','of','in','and','with','your',
    'more','increase','boost','want','need','can','do','does','is','it','please','service','services','online',
    'instant','fast','safe','legit','top','quick','now','site','website'];

  // 4) Узагальнені слова: відкидаємо на другому кроці каскаду
  SV.GENERIC = ['promotion','music','song','track','account','profile','page','channel','video','post','organic','real','usa'];

  // 5) Службові наміри → рядок «Help» над результатами
  SV.HELP = [
    {k:['refund','refunds','withdrawal','cancel'], t:'Refund policy', u:'policies/refund-policy'},
    {k:['support','contact','help','email','whatsapp','problem','issue'], t:'Contact support', u:'pages/contact-us'},
    {k:['faq','question','questions','safe','legit','scam','guarantee','delivery','shipping','long'], t:'FAQ', u:'pages/faq'},
    {k:['discount','coupon','code','codes','promocode','sale','sales','offer','deal','deals','cupon','rabatt'], t:'Unlock discount', gift:true},
    {k:['order','orders','purchase','purchases','status','tracking','login','signin'], t:'My orders', u:'account'},
    {k:['royalty','royalties','calculator','earn','earnings','monetization','monetize','payout'], t:'How artists get paid (royalties)', u:'blogs/news/music-royalties'},
    {k:['promosound','psg'], t:'About PromoSound', u:'pages/about-us'},
    {k:['paypal','payment','pay','card','crypto','billing','invoice'], t:'Payment questions - FAQ', u:'pages/faq'}
  ];

  // Damerau-Levenshtein (обмежений) для опечаток
  SV.dl = function (a, b) {
    var al = a.length, bl = b.length, d = [], i, j;
    if (Math.abs(al - bl) > 2) return 9;
    for (i = 0; i <= al; i++) { d[i] = [i]; }
    for (j = 0; j <= bl; j++) { d[0][j] = j; }
    for (i = 1; i <= al; i++) for (j = 1; j <= bl; j++) {
      var c = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
    return d[al][bl];
  };

  SV.vocab = null; // слова каталогу (≥4 літер) + платформи; будується з INDEX
  SV.buildVocab = function (INDEX, PLATFORMS) {
    var seen = {}, out = [];
    function add(w) { if (w && w.length >= 4 && !seen[w] && !/\d/.test(w)) { seen[w] = 1; out.push(w); } }
    INDEX.forEach(function (p) { p.words.forEach(add); });
    PLATFORMS.forEach(add); add('soundcloud');
    SV.vocab = out; SV.vocabSet = seen;
  };

  // Опечатка → слово каталогу: DL≤1 (≤2 для довгих), або «склеєний» префікс платформи (tiktl→tiktok)
  SV.fix = function (tok, PLATFORMS) {
    if (tok.length < 4 || SV.vocabSet[tok]) return tok;
    var best = null, bd = 9, lim = tok.length >= 8 ? 2 : 1;
    for (var i = 0; i < SV.vocab.length; i++) {
      var w = SV.vocab[i]; if (Math.abs(w.length - tok.length) > lim) continue;
      var d = SV.dl(tok, w); if (d < bd) { bd = d; best = w; }
    }
    if (best && bd <= lim) return best;
    for (var p = 0; p < PLATFORMS.length; p++) {
      var pl = PLATFORMS[p];
      for (var n = Math.min(pl.length, tok.length); n >= 3; n--) if (tok.indexOf(pl.slice(0, n)) === 0) return pl;
    }
    return tok;
  };

  // Число з одиницями → ціле як рядок: '10k'→'10000', '1m'/'1million'→'1000000'; інакше null
  SV.num = function (t) {
    var m = /^(\d+(?:[.,]\d+)?)(k|m|million|millions|thousand)?$/.exec(t);
    if (!m) return null;
    var v = parseFloat(m[1].replace(',', '.')), u = m[2];
    if (u === 'k' || u === 'thousand') v *= 1000; else if (u) v *= 1000000;
    return String(Math.round(v));
  };

  SV.URLS = [['tiktok.com','tiktok'],['instagram.com','instagram'],['youtube.com','youtube'],['youtu.be','youtube'],
    ['spotify.com','spotify'],['soundcloud.com','soundcloud'],['facebook.com','facebook'],['twitch.tv','twitch'],['beatport.com','beatport']];

  // Нормалізація v2 → {tokens, free, help}
  SV.normalize = function (q, PLATFORMS) {
    var s = ' ' + q.toLowerCase().trim().replace(/\s+/g, ' ') + ' ';
    var i, free = false, help = [], helpSeen = {};
    for (i = 0; i < SV.URLS.length; i++) if (s.indexOf(SV.URLS[i][0]) !== -1) return {tokens: [SV.URLS[i][1]], nums: [], free: false, help: []};
    for (i = 0; i < SV.PHRASES.length; i++) s = s.split(' ' + SV.PHRASES[i][0] + ' ').join(' ' + SV.PHRASES[i][1] + ' ');
    s = s.replace(/(\d)[ .,](?=\d{3}\b)/g, '$1').replace(/(\d) (k|m|million|millions|thousand)\b/g, '$1$2');
    var raw = s.split(/[\s,.;:!?\/\\|+()"'‘’“”«»@#&*_=\[\]{}<>$%]+/).filter(Boolean);
    var toks = [];
    raw.forEach(function (t) {
      if (t.length > 4 && t.indexOf('free') === 0) { free = true; t = t.slice(4); }  // freetiktok, freeinstafl
      if ((t === 'streams' || t === 'stream') && !/apple|itunes|boomplay/.test(s)) t = 'plays';   // Apple Music Streams, Boomplay Streams (29.09) - виняток
      var m = SV.WORDS[t]; if (m) t = m;
      t.split(' ').forEach(function (x) { if (x) toks.push(x); });
    });
    var out = [], nums = [];
    toks.forEach(function (t) {
      if (t === 'free') { free = true; return; }
      SV.HELP.forEach(function (h, hi) { if (h.k.indexOf(t) !== -1 && !helpSeen[hi]) { helpSeen[hi] = 1; help.push(h); } });
      if (SV.STOP.indexOf(t) !== -1) return;
      var num = SV.num(t); if (num) { nums.push(num); return; }                 // кількості: 1000, 10k, 1m → бонус, не умова
      if (!/^[a-z0-9-]+$/.test(t)) return;                                      // інші скрипти, що не в словнику
      t = SV.fix(t, PLATFORMS);
      var m2 = SV.WORDS[t]; if (m2) t = m2;
      t.split(' ').forEach(function (x) { if (x) out.push(x); });
    });
    var joined = out.join(' ').replace(/sound\s*cloud|soundcloud/g, 's-cloud');
    var tk = joined.split(/[^a-z0-9]+/).filter(Boolean);
    if (tk.length > 1) tk = tk.filter(function (t, i) { return t.length > 1 || (t === 's' && tk[i + 1] === 'cloud'); });
    if (!tk.length && nums.length && !/[a-z]/.test(q.toLowerCase()) && !free && !help.length) tk = nums.slice(); // лише цифри - як раніше
    return {tokens: tk, nums: nums, free: free, help: help};
  };

  // Порядок платформ за попитом (GA4 25.09): при рівному балі популярніша вище
  SV.PRIO = ['tiktok','instagram','youtube','spotify','s-cloud','facebook','audiomack','boomplay','shazam','reverbnation','deezer','mixcloud','apple','tidal','beatport','pandora','napster','twitch','bandcamp','threads','itunes','traxsource','resident'];
  SV.prio = function (pr) {
    for (var i = 0; i < SV.PRIO.length; i++) if (pr.u.indexOf(SV.PRIO[i]) !== -1 || pr.words.indexOf(SV.PRIO[i]) !== -1) return i + 1;
    // радіо / блоги / гайд - власна «платформа»: на запит «radio»/«blog» вони і є відповіддю; решта (Artist-бандли) - в кінці
    for (var j = 0; j < pr.words.length; j++) if (/^(radio|blog|blogs|guide|pdf)$/.test(pr.words[j])) return 0;
    return SV.PRIO.length + 1;
  };

  // Головна метрика при рівному балі (запит лише з назви платформи): plays → followers → views → …
  SV.METRICS = ['plays', 'followers', 'views', 'subscribers', 'listeners', 'likes', 'saves', 'comments', 'reposts', 'shares'];
  SV.metric = function (pr) {
    for (var i = 0; i < SV.METRICS.length; i++) if (pr.words.indexOf(SV.METRICS[i]) !== -1) return i;
    return SV.METRICS.length;
  };

  // Каскад: строгий AND → без невідомих слів → без узагальнених → лише платформа → найкращий частковий.
  // nums - бонус (точний збіг числа в назві, напр. бандл «500 Followers»), не умова.
  // scOnly (запит про SoundCloud) - ніколи не виходимо за S-Cloud.
  SV.search = function (INDEX, tokens, nums, scOnly, score, isPlatform) {
    function isSc(pr) { return pr.u.indexOf('s-cloud') !== -1; }
    // бонус лише коли в назві «ЧИСЛО МЕТРИКА» збігається з запитом: «500 followers» ✓, «10000 views» на запит subscribers ✗
    function numBonus(pr, tk) {
      var b = 0;
      for (var i = 0; i < nums.length; i++) {
        var at = pr.words.indexOf(nums[i]);
        if (at === -1) continue;
        var next = pr.words[at + 1] || '';
        if (!tk.length) { b += 3; continue; }
        for (var j = 0; j < tk.length; j++) if (tk[j].length >= 3 && next.indexOf(tk[j]) === 0) { b += 3; break; }
      }
      return b;
    }
    function order(list) {
      list.sort(function (a, b) {
        return b[0] - a[0] ||
          (scOnly ? 0 : (isSc(a[1]) ? 1 : 0) - (isSc(b[1]) ? 1 : 0)) ||      // S-Cloud вище лише на SoundCloud-запит
          SV.prio(a[1]) - SV.prio(b[1]) ||                                     // платформа за попитом
          (/^buy /i.test(b[1].t) ? 1 : 0) - (/^buy /i.test(a[1].t) ? 1 : 0) || // головні «Buy …» вище підпродуктів
          SV.metric(a[1]) - SV.metric(b[1]) ||                                 // «spotify» → Plays, а не Saves
          a[1].t.length - b[1].t.length;
      });
      return list.slice(0, 8).map(function (x) { return x[1]; });
    }
    function rank(tk) {
      if (!tk.length) return [];
      var out = [];
      for (var i = 0; i < INDEX.length; i++) {
        var pr = INDEX[i];
        if (scOnly && !isSc(pr)) continue;
        var v = score(pr, tk); if (v > 0) out.push([v + numBonus(pr, tk), pr]);
      }
      return order(out);
    }
    function known(t) { for (var i = 0; i < INDEX.length; i++) if (score(INDEX[i], [t]) >= 4) return true; return false; }
    var k1 = tokens.filter(known);
    var steps = [tokens, k1, k1.filter(function (t) { return SV.GENERIC.indexOf(t) === -1; }), tokens.filter(isPlatform)];
    for (var s = 0; s < steps.length; s++) {
      if (!steps[s].length || (s && steps[s].join() === steps[s - 1].join())) continue;
      var h = rank(steps[s]);
      if (h.length) return {hits: h, step: s};
    }
    var strong = tokens.filter(function (t) { return t.length >= 3 && known(t) && SV.GENERIC.indexOf(t) === -1; });
    if (strong.length >= 2) {
      var out = [];
      INDEX.forEach(function (pr) {
        if (scOnly && !isSc(pr)) return;
        var n = 0; strong.forEach(function (t) { if (score(pr, [t]) >= 4) n++; });
        if (n) out.push([n * 5 + numBonus(pr, strong), pr]);
      });
      if (out.length) return {hits: order(out), step: 4};
    }
    return {hits: [], step: -1};
  };

  function isPlatformTok(t) { return PLATFORMS.indexOf(t) !== -1 || t === 'cloud' || t === 'apple' || t === 'resident'; }

  // Службовий намір (order/refund/discount/support…) - рядок над товарами; discount = eSputnik-віджет
  function rowHelp(h) {
    var arrow = '<svg class="psq-row__arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    if (h.gift) return '<button type="button" class="psq-row psq-row--help hot-offers-button" data-psq-gift><span class="psq-row__ico"></span><span class="psq-row__title">' + esc(h.t) + '</span>' + arrow + '</button>';
    return '<a class="psq-row psq-row--help" href="' + ROOT + h.u + '"><span class="psq-row__ico"></span><span class="psq-row__title">' + esc(h.t) + '</span>' + arrow + '</a>';
  }

  // Фірмові кольорові іконки платформ (ті самі, що в картках/кошику/чекауті) —
  // класи зі style-card-ico.css; порядок = product-platform-icon-class.liquid
  var PLAT_ICONS = [
    ['itunes', 'itunes-top-100-promotion-usa'],
    ['apple', 'buy-apple-music-streams'],
    ['audiomack', 'buy-audiomack-plays'],
    ['boomplay', 'boomplay-promotion'],
    ['shazam', 'shazam-promotion'],
    ['reverbnation', 'reverbnation-promotion'],
    ['s-cloud', 'soundcloud-promotion'],
    ['youtube', 'youtube-promotion'],
    ['spotify', 'spotify-promotion'],
    ['tiktok', 'tiktok-promotion'],
    ['instagram', 'instagram-promotion'],
    ['facebook', 'facebook-promotion'],
    ['beatport', 'beatport-promotion'],
    ['resident', 'resident-advisor-promotion'],
    ['twitch', 'twitch-promotion'],
    ['threads', 'threads-promotion'],
    ['traxsource', 'traxsource-top-100-promotion'],
    ['deezer', 'deezer-promotion'],
    ['tidal', 'tidal-promotion'],
    ['bandcamp', 'bandcamp-promotion'],
    ['pandora', 'buy-pandora-music-plays'],
    ['napster', 'buy-napster-plays'],
    ['mixcloud', 'mixcloud-promotion'],
    ['radio', 'radio-airplay'],
    ['blog', 'music-blogs-placement'],
    ['guide', 'music-guides'],
    ['hip-hop', 'hip-hop-promotion'],
    ['hip hop', 'hip-hop-promotion'],
    ['artist', 'artist-promotion']
  ];

  function platformClass(p) {
    var src = ((p.title || '') + ' ' + (p.url || '')).toLowerCase();
    for (var i = 0; i < PLAT_ICONS.length; i++) {
      if (src.indexOf(PLAT_ICONS[i][0]) !== -1) return PLAT_ICONS[i][1];
    }
    return null;
  }

  function rowNative(p) {
    var pv = '';
    if (p.price != null) {
      var varies = (p.price_min != null && p.price_max != null && p.price_min !== p.price_max);
      pv = (varies ? '<span class="psq-row__from">From</span> ' : '') + '$' + esc(String(p.price));
    }
    var price = pv ? '<span class="psq-row__price">' + pv + '</span>' : '';
    var pc = platformClass(p);
    var ico = pc ? '<span class="psq-row__ico psq-row__ico--plat ' + pc + '"><i class="svc-card__image"></i></span>'
      : (p.image ? '<span class="psq-row__ico" style="background-image:url(' + p.image + ')"></span>'
                 : '<span class="psq-row__ico"></span>');
    return '<a class="psq-row" href="' + p.url + '">' + ico +
      '<span class="psq-row__title">' + esc(p.title) + '</span>' + price +
      '<svg class="psq-row__arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
  }

  // Витягнути прихований S-Cloud блок (кеш на сесію), відфільтрувати за під-запитом
  function fetchScloud() {
    if (scloudCache) return Promise.resolve(scloudCache);
    return fetch(ROOT + '?section_id=ps-scloud-suggest', { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        scloudCache = Array.prototype.slice.call(tmp.querySelectorAll('.psq-row'));
        return scloudCache;
      })
      .catch(function () { return []; });
  }

  // Популярні платформи — [label, шлях від root АБО запит, тип] — ВСІ href-цілі перевірені на 200 (без 404/301!)
  // 16.10.2026: порядок за рішенням власника — Radio Airplay і Music Blogs вперед (просування нових товарів),
  // далі SoundCloud (63% реального пошукового попиту, стат. серпень), решта без змін.
  // Radio Airplay / Music Blogs - тип 'q': немає єдиної профільної сторінки на кілька товарів (на відміну від
  // колекцій платформ), тож клік підставляє запит у поле (як Recent-чип) і видає ранжовану видачу з кількох товарів.
  var POPULAR = [
    ['Radio Airplay', 'radio airplay', 'q'],
    ['SoundCloud', 'collections/s-cloud-promotion'],
    ['Music Blogs', 'music blogs', 'q'],
    ['Spotify', 'collections/spotify-promotion'], ['YouTube', 'collections/youtube-promotion'],
    ['TikTok', 'collections/tiktok-promotion'], ['Instagram', 'collections/new-instagram-promo'],
    ['Apple Music', 'products/buy-apple-music-streams']
  ];

  function chipsHtml(msg) {
    var html = '<div class="psq-empty"><p class="psq-empty__msg">' + msg + '</p><div class="psq-chips">';
    POPULAR.forEach(function (p) {
      html += p[2] === 'q'
        ? '<button type="button" class="psq-chip psq-chip--query" data-q="' + esc(p[1]) + '">' + esc(p[0]) + '</button>'
        : '<a class="psq-chip" href="' + ROOT + p[1] + '">' + esc(p[0]) + '</a>';
    });
    return html + '</div></div>';
  }

  function chips() { return chipsHtml('No matches. Explore popular platforms:'); }

  // Останні запити юзера (localStorage, до 3)
  function getRecent() {
    try { return JSON.parse(localStorage.getItem('psq_recent') || '[]'); } catch (e) { return []; }
  }
  function saveRecent(q) {
    if (!q || q.length < MIN) return;
    try {
      var r = getRecent().filter(function (x) { return x !== q; });
      r.unshift(q);
      localStorage.setItem('psq_recent', JSON.stringify(r.slice(0, 3)));
    } catch (e) {}
  }

  // Empty-state до першого символу: recent + популярне + одна ЧБ-кнопка Best Sellers
  function renderEmpty() {
    var html = '';
    var recent = getRecent();
    if (recent.length) {
      html += '<div class="psq-group__label">Recent</div><div class="psq-chips" style="padding:0 18px 4px;">';
      recent.forEach(function (r) {
        html += '<button type="button" class="psq-chip psq-chip--recent" data-q="' + esc(r) + '">' + esc(r) + '</button>';
      });
      html += '</div>';
    }
    html += chipsHtml('Popular searches:');
    var giftSvg = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.333 5.333H2.667A.667.667 0 002 6v2a.667.667 0 00.667.667h10.666A.667.667 0 0014 8V6a.667.667 0 00-.667-.667zM8 5.333V14M3.333 8.667V13.333a.667.667 0 00.667.667h8a.667.667 0 00.667-.667V8.667M5.667 5.333c-.737 0-1.334-.597-1.334-1.333S4.93 2.667 5.667 2.667C7.333 2.667 8 5.333 8 5.333S6.333 5.333 5.667 5.333zM10.333 5.333c.737 0 1.334-.597 1.334-1.333S11.07 2.667 10.333 2.667C8.667 2.667 8 5.333 8 5.333s1.667 0 2.333 0z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    html += '<div class="psq-actions">' +
      '<a class="psq-chip psq-chip--bsone" href="' + ROOT + 'collections/best-sellers">Best Sellers</a>' +
      '<button type="button" class="psq-chip psq-chip--gift hot-offers-button" data-psq-gift>' + giftSvg + 'Unlock discount</button>' +
      '</div>';
    box.innerHTML = html;
    box.hidden = false;
  }

  function footer(q, count, scHit) {
    var href = scHit ? SC_COLLECTION : (ROOT + 'search?q=' + encodeURIComponent(q) + '&type=product');
    return '<a class="psq-all" href="' + href + '">Show all results &rarr;</a>';
  }

  function render(q, nativeProducts, scRows) {
    var parts = [];
    if (scRows && scRows.length) {
      parts.push('<div class="psq-group__label">Packages</div>');
      scRows.forEach(function (el) { parts.push(el.outerHTML); });
    }
    // Для запиту-синоніма показуємо ЛИШЕ S-Cloud (без нативного шуму типу Mixcloud).
    // Нативні продукти додаємо тільки коли S-Cloud блоку нема.
    if (!(scRows && scRows.length)) {
      var natHtml = [];
      (nativeProducts || []).forEach(function (p) { natHtml.push(rowNative(p)); });
      parts = parts.concat(natHtml);
    }
    lastCount = parts.length;
    if (!parts.length) {
      box.innerHTML = chips();
      box.hidden = false;
      return;
    }
    parts.push(footer(q, parts.length, !!(scRows && scRows.length)));
    box.innerHTML = parts.join('');
    box.hidden = false;
  }

  function run(q) {
    var nq = normalizeQuery(q); // толерантність до типо/синонімів (фолбек-шлях без індексу)
    var scWanted = isScloud(nq);

    // МИТТЄВИЙ локальний шлях: весь каталог, кожна літера, без мережі. v2: словник + каскад (SV)
    if (INDEX) {
      if (!SV.vocab) SV.buildVocab(INDEX, PLATFORMS);
      var n = SV.normalize(q, PLATFORMS);
      scWanted = isScloud(n.tokens.join(''));
      var hits = SV.search(INDEX, n.tokens, n.nums, scWanted, scoreProduct, isPlatformTok).hits;
      var parts = [];
      n.help.forEach(function (h) { parts.push(rowHelp(h)); });
      if (scWanted && hits.length) parts.push('<div class="psq-group__label">Packages</div>');
      hits.forEach(function (pr) {
        parts.push(rowLocal(pr, platformClass({ title: pr.t, url: pr.u })));
      });
      lastCount = hits.length;
      if (!parts.length) {
        box.innerHTML = chips();
        box.hidden = false;
        return;
      }
      if (hits.length) parts.push(footer(q, parts.length, scWanted));
      box.innerHTML = parts.join('');
      box.hidden = false;
      return;
    }

    var nativeP = fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(nq) +
        '&resources[type]=product&resources[limit]=' + LIMIT +
        '&resources[options][prefix]=last' +
        '&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d.resources && d.resources.results && d.resources.results.products) || []; })
      .catch(function () { return []; });

    var scP = scWanted ? fetchScloud().then(function (rows) {
      // під-фільтр: якщо після синоніма є ще слово (напр. "soundcloud plays")
      var extra = nq.replace(/s-?cloud|sound\s*cloud|scloud/g, '').replace(/[^a-z]/g, '');
      if (extra.length >= 3) {
        var f = rows.filter(function (el) { return (el.getAttribute('data-t') || '').indexOf(extra) !== -1; });
        return (f.length ? f : rows).slice(0, SC_MAX);
      }
      return rows.slice(0, SC_MAX);
    }) : Promise.resolve([]);

    Promise.all([nativeP, scP]).then(function (res) {
      if (q !== lastQuery) return; // застарілий запит
      render(q, res[0], res[1]);
    });
  }

  var clearBtn;

  function syncClear() {
    if (clearBtn) clearBtn.hidden = !input.value.length;
  }

  function onInput() {
    var q = input.value.trim();
    lastQuery = q;
    clearTimeout(timer);
    syncClear();
    if (q.length < MIN) { renderEmpty(); return; }
    timer = setTimeout(function () { run(q); }, DEBOUNCE);
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function () { commitSearch('idle'); }, IDLE_COMMIT);
  }

  // Клавіатурна навігація по підказках
  function highlight(dir) {
    var rows = Array.prototype.slice.call(box.querySelectorAll('.psq-row, .psq-all'));
    if (!rows.length) return;
    var cur = box.querySelector('.is-hl');
    var i = cur ? rows.indexOf(cur) + dir : (dir > 0 ? 0 : rows.length - 1);
    if (cur) cur.classList.remove('is-hl');
    if (i >= 0 && i < rows.length) {
      rows[i].classList.add('is-hl');
      rows[i].scrollIntoView({ block: 'nearest' });
    }
  }

  function init() {
    input = document.getElementById('Search');
    box = document.getElementById('psq-results');
    clearBtn = document.getElementById('psq-clear');
    if (!input || !box) return;
    syncClear();

    input.addEventListener('input', onInput);

    // Стан при відкритті: порожньо → empty-state; є текст (напр. на /search
    // Liquid підставив query) → одразу підказки
    function openState() {
      syncClear();
      var q = input.value.trim();
      if (q.length < MIN) { if (box.hidden || !box.innerHTML) renderEmpty(); }
      else { lastQuery = q; run(q); }
    }

    input.addEventListener('focus', function () {
      loadIndex();
      if (box.hidden) openState();
    });

    // Відкриття модала кліком по лупі (фокус ставить script-mini-cart — дублюємо надійно)
    document.addEventListener('click', function (e) {
      if (e.target.closest('.search-trigger')) {
        window.psTrack && psTrack('search_open', { src: 'header' });
        loadIndex();
        setTimeout(openState, 50);
      }
    });

    clearBtn && clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      syncClear();
      renderEmpty();
    });

    // Enter/submit: синонім прихованої категорії → одразу колекція
    var form = input.closest('form');
    form && form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      saveRecent(q);
      commitSearch('enter');
      if (isScloud(normalizeQuery(q))) { e.preventDefault(); window.location.href = SC_COLLECTION; }
    });

    // кліки: recent-чип → підставити запит; решта → аналітика
    box.addEventListener('click', function (e) {
      var gift = e.target.closest('[data-psq-gift]');
      if (gift) {
        // 26.09.2026: eSputnik чіпляє віджет 30072 лише до .hot-offers-button, що були в HTML при завантаженні
        // (перевірено: статична кнопка hero відкриває, динамічна - ні). Кнопка в пошуку малюється при відкритті,
        // тож eSputnik її не бачить. Тому закриваємо пошук і клікаємо статичну кнопку меню (#menu-item-hot-offers,
        // є на кожній сторінці) - віджет відкривається так само, як з hero.
        window.psTrack && psTrack('search_unlock_discount_click');
        var modal0 = document.getElementById('search-modal');
        modal0 && modal0.classList.remove('active'); // віджет з'являється над сторінкою
        var staticBtn = document.getElementById('menu-item-hot-offers') ||
          document.querySelector('.hot-offers-button:not([data-psq-gift])');
        if (staticBtn) setTimeout(function () { staticBtn.click(); }, 0);
        return;
      }
      // Recent-чип і query-чип (Radio Airplay/Music Blogs) працюють однаково - підставити запит і шукати
      var rc = e.target.closest('.psq-chip--recent, .psq-chip--query');
      if (rc) {
        input.value = rc.getAttribute('data-q') || '';
        input.focus();
        onInput();
        return;
      }
      var a = e.target.closest('.psq-row, .psq-all, .psq-chip');
      if (a) {
        a.classList.add('is-loading'); // фірмовий ring до переходу (буває, думає)
        saveRecent(input.value.trim());
        commitSearch('click');
        window.psTrack && psTrack('search_suggest_click', { href: a.getAttribute('href'), search_term: input.value.trim() }, { search_term: input.value.trim() });
      }
    });

    // Клавіатура: ↑↓ по рядках, Enter по підсвіченому, Esc закриває модал
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(-1); }
      else if (e.key === 'Enter') {
        var hl = box.querySelector('.is-hl');
        if (hl) { e.preventDefault(); saveRecent(input.value.trim()); commitSearch('click'); window.location.href = hl.getAttribute('href'); }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var modal = document.getElementById('search-modal');
        if (modal && modal.classList.contains('active')) { commitSearch('close'); modal.classList.remove('active'); }
      }
    });

    // Клік по затемненню закриває (панель — stopPropagation через перевірку target)
    var modal = document.getElementById('search-modal');
    modal && modal.addEventListener('click', function (e) {
      if (e.target === modal) { commitSearch('close'); modal.classList.remove('active'); }
    });

    // Пошук у сайд-меню: тап по полю → схлопнути меню, відкрити нашу модалку
    document.addEventListener('pointerdown', function (e) {
      var menuSearch = e.target.closest('.sliding-menu .search-input-container');
      if (!menuSearch) return;
      e.preventDefault();
      document.getElementById('closeButton') && document.getElementById('closeButton').click();
      setTimeout(function () {
        modal && modal.classList.add('active');
        input.focus();
        syncClear();
        if (input.value.trim().length < MIN) renderEmpty();
        window.psTrack && psTrack('search_open', { src: 'menu' });
      }, 120);
    });
  }

  window.addEventListener('pagehide', function () { commitSearch('leave'); });
  document.addEventListener('click', function (e) { if (e.target.closest('#close-modal')) commitSearch('close'); });

  // Движок для офлайн-аудиту (scripts/search-queries-report.py ганяє реальні запити через ЦЕЙ код, не копію)
  window.PSQ = { SV: SV, PLATFORMS: PLATFORMS, scoreProduct: scoreProduct, isPlatformTok: isPlatformTok, isScloud: isScloud, SC_PACKAGES: SC_PACKAGES };

  // bfcache-повернення: прибрати залишкові лоадери
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('#psq-results .is-loading').forEach(function (el) { el.classList.remove('is-loading'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
